module.exports = __webpack_public_path__ + "media/images/user-portal-documentation-icon-d8bb8b96e4e6a1cfec827b3e1de4b8ad.svg";